import React from "react";
// import './robo.css'

const Card= ({name,email ,id})=>{
    // const  {name,email ,id} = props
    return(
        <div className="tc bg-light-green dib br3 pa3 ma2 grow bw2 shadow-S">
           
           <img src={`https://robohash.org/${id}`}alt="photo"></img>
            <h2>{name}</h2>
            <p>{email}</p>
        </div>
    )
}
export default Card;

//  <img src="https://robohash.org/test" alt="photo"></img>

// {/* <img src={`https://robohash.org/${props.id}`} */}
// {/* <h2>{props.name}</h2>
//             <p>{props.email}</p> */}

// const card = (props) =>{}
// const  {name,email ,id} = props 
// here props = name id emai.. so in place props in aboveconst card replace{name , i d email}


// we know  decontrsuctor 
// var person = {
//     firstName : "John",
//     lastName  : "Doe",
//     age       : 50,
//     eyeColor  : "blue"
// };
// var {firstname , age  } = person